import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { z } from "zod";

const filterK2PdfPageSelectionSchema = z.object({
  client_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  page_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  tableau_view_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  tableau_workbook_id_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterK2PdfPageSelectionSchema = z.infer<
  typeof filterK2PdfPageSelectionSchema
>;

const fields: Field[] = [
  {
    name: "client_contains",
    label: `Client`,
    type: "asyncAutocomplete",
    base_url: "k2/k2_pdf_page_selection",
    column_name: "client",
  },
  {
    name: "page_name_contains",
    label: `Nom de la page`,
    type: "asyncAutocomplete",
    base_url: "k2/k2_pdf_page_selection",
    column_name: "page_name",
  },
  {
    name: "tableau_view_contains",
    label: `Vue Tableau`,
    type: "asyncAutocomplete",
    base_url: "k2/k2_pdf_page_selection",
    column_name: "tableau_view",
  },
  {
    name: "tableau_workbook_id_contains",
    label: `ID du classeur Tableau`,
    type: "asyncAutocomplete",
    base_url: "k2/k2_pdf_page_selection",
    column_name: "tableau_workbook_id",
  },
  {
    name: "created_at",
    type: "dateRange",
    label: "Date de création",
    from: { name: "created_at_from" },
    to: { name: "created_at_to" },
  },
];

const client = "k2";

export function K2PdfPageSelectionFilter() {
  return (
    <FilterTable
      client={client}
      schema={filterK2PdfPageSelectionSchema}
      tableName="k2_pdf_page_selection"
      fields={fields}
    />
  );
}
